import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MaintenanceTermDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/maintenance-record/maintenance-term-dto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ListMaintenanceTermService {

  constructor(private httpClient: HttpClient) { }


  listMaintenaceTerm() {
    return this.httpClient.get<MaintenanceTermDto[]>(`${environment.apiServer}/Adjuster/Claim/ListMaintenanceTerm`);
  }
}
